import { loadStripe } from '@stripe/stripe-js';

const isDevelopment = window.location.href.includes('localhost');
const STRIPE_PUBLISHABLE_KEY =
  isDevelopment
    ? 'pk_test_51I6PYnHj1UkrSfve8SN2ABn7G98QGSXyOCbK1clkWWJadfvNOUSwa2EFlOq8qI8zAfvDrLseZoSWHq6Sr53OI2F4002aZJBqY8'
    : 'pk_live_51I6PYnHj1UkrSfvewIg6geHEeEYhjrQDjEQzDIHpIS7IGWaxFmVfiwdeJcXCbb7dQUgj4D2zUncXdq4Lju6LlJYE00q2qS9Vsn';

const stripeService = {
  getStripe() {
    try {
      return loadStripe(STRIPE_PUBLISHABLE_KEY);
    } catch (error) {
      console.error('Error loading Stripe:', error);
      throw error;
    }
  },
};

export default stripeService;